// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2M-0z","location":"Header_location__19QFq"};